<template>
  <v-container
    id="detalhe-principais-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <v-col
                cols="12"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    lg="2"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedPrimeiroDia"
                          label="Data Inical"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="primeiroDia"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    id="menu1"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="2"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedDateFormatted"
                          label="Data Final"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="ultimoDia"
                        no-title
                        @input="menu1 = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="6"
                  >
                    <v-select
                      v-model="select"
                      :items="empresa"
                      item-value="id"
                      item-text="nomeExibicao"
                      label="Empresas"
                      multiple
                      return-object
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    lg="2"
                  >
                    <v-btn
                      id="btnRefazer"
                      class="col-12 lg-12 text-h4"
                      small
                      :color="corPrimaria"
                      dark
                      @click="updateDate()"
                    >
                      <v-icon>
                        mdi-reload-alert
                      </v-icon>
                      Refazer
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-container>
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-row id="relatorioClientesFaturados">
                        <v-col
                          id="relatorioClientesFaturados"
                          cols="9"
                          class="text-left"
                        >
                          Como está o faturamento dos meus produtos?
                        </v-col>
                        <v-col
                          cols="1"
                        >
                          <v-btn
                            id="btnPrint"
                            class="col-12 lg-12"
                            small
                            :disabled="enableBtn"
                            :color="corPrimaria"
                            dark
                            @click="imprimir()"
                          >
                            <v-icon>
                              mdi-printer
                            </v-icon>
                            Imprimir
                          </v-btn>
                        </v-col>
                        <v-col
                          cols="1"
                        >
                          <v-tooltip top>
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationClientesFaturados"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('317')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="codigo === '317'"
                              v-html="textoDetalhesFatClassificacao"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="loading">
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <div
                            :style="styleObject"
                            class="text-center"
                          >
                            <v-icon
                              light
                              class="custom-loader"
                              :style="styleObject"
                            >
                              mdi-cached
                            </v-icon>
                            Carregando dados...
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="error">
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <div
                            class="alert alert-danger"
                          >
                            {{ error }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-row
                          id="filtrosPrint"
                          class="hidden"
                        >
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <h3 class="text-center">
                              Filtros Selecionados:
                            </h3>
                            <div class="text-center">
                              Data Inicial: {{ dataInicialImpressao }}
                            </div>
                            <div class="text-center">
                              Data Final: {{ dataFinalImpressao }}
                            </div>
                            <div
                              v-if="select.length > 0"
                              class="'text-center'"
                            >
                              Empresas selecionadas:
                              <ul class="no-list-style">
                                <li
                                  v-for="empresa in select"
                                  :key="empresa"
                                >
                                  {{ empresa.nomeExibicao }}
                                </li>
                              </ul>
                            </div>
                          </v-col>
                        </v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <v-data-table
                            id="headersGrupoProdutos"
                            :headers="headersGrupoProdutos"
                            :items="faturamentoGrupoProdutos"
                            :items-per-page="faturamentoGrupoProdutos.length"
                            :height="faturamentoGrupoProdutos.length < 7 ? (faturamentoGrupoProdutos.length === 0 ? 1 * 48 + 48 + 'px' : faturamentoGrupoProdutos.length * 48 + 48 + 'px') : '500px'"
                            fixed-header
                            disable-sort
                            hide-default-footer
                            class="elevation-1"
                            style="color: black"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Vendas from '../../../../../services/vendas'
  import Permissao from '../../../../../services/menu'

  export default {
    name: 'DashboardFaturamentoProdutos',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaId')),
      empresa: [],
      menu: false,
      menu1: false,
      loading: false,
      error: null,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesFatClassificacao: '',
      headersGrupoProdutos: [
        { text: 'Vendedor', value: 'vendedor', width: '150px', class: 'black--text title' },
        { text: 'Produto', value: 'grupo_produto', width: '200px', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês do Ano Anterior', value: 'faturamento_anterior', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual', value: 'variacao_anual', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Participação da Linha', value: 'participacao_grupo', width: '150px', align: 'right', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtn: true,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoVendas'))

        Permissao.showEmpresas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.empresas) {
              this.empresa.push(resposta.data.empresas[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0).toISOString().substr(0, 10)

        if (date > dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser maiores que 2 meses da data atual')

          var data = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0).toISOString().substr(0, 10)

          const [year, month, day] = data.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toISOString().substr(0, 10)

        if (date < dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser menores que 2 meses da data atual')

          const [year, month, day] = dataLimite.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '317') {
            this.textoDetalhesFatClassificacao = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.faturamentoGrupoProdutos = []

        this.formatarDatasImpressao()

        this.showDelhamentoFaturamentoProdutos()
      },

      imprimir () {
        var filtros = document.getElementById('filtrosPrint').innerHTML
        var conteudo = document.getElementById('headersGrupoProdutos').innerHTML

        var telaImpressao = window.open()

        var impressao = filtros + conteudo

        telaImpressao.document.write(impressao)
        telaImpressao.window.print()
        telaImpressao.window.close()
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      async showDelhamentoFaturamentoProdutos () {
        this.loading = true
        this.enableBtn = true

        await Vendas.showDelhamentoProdutos(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.faturamentoGrupoProdutos = resposta.data.dadosExibicao.map((item) => {
              var listaFaturamento = ({
                vendedor: item.vendedor,
                grupo_produto: item.grupo_produto,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento_anterior: item.faturamento_anterior ? parseFloat(item.faturamento_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
                variacao_anual: item.variacao_anual ? parseFloat(item.variacao_anual).toFixed(2) + '%' : '',
                participacao_grupo: item.participacao_grupo ? parseFloat(item.participacao_grupo).toFixed(2) + '%' : '',
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>
<style lang="sass">
  #btnPrint
    margin: 0 0 0 9rem

  #relatorioClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationClientesFaturados
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
